import { createContext, useContext, useEffect, useState } from "react";

const AppContext = createContext();
const FILTERS_STORAGE_KEY = "app:filters";
const DEFAULT_FILTERS = {
  temporada: null,
  temporadaNombre: "",
  federacion: null,
  federacionNombre: "",
  categoria: null,
  competicion: null,
  grupo: null,
};

const getInitialFilters = () => {
  if (typeof window === "undefined") {
    return DEFAULT_FILTERS;
  }

  const storedFilters = window.localStorage.getItem(FILTERS_STORAGE_KEY);
  if (!storedFilters) {
    return DEFAULT_FILTERS;
  }

  try {
    const parsedFilters = JSON.parse(storedFilters);
    if (
      parsedFilters &&
      typeof parsedFilters === "object" &&
      !Array.isArray(parsedFilters)
    ) {
      return { ...DEFAULT_FILTERS, ...parsedFilters };
    }
  } catch {
    window.localStorage.removeItem(FILTERS_STORAGE_KEY);
  }

  return DEFAULT_FILTERS;
};

export const AppProvider = ({ children }) => {
  // 🔹 Estados globales actuales
  const [jornadas, setJornadas] = useState([]);
  const [filters, setFilters] = useState(getInitialFilters);
  const [clasificaciones, setClasificaciones] = useState([]);

  // 🔹 Ejemplo de otros estados que puedes añadir más adelante
  const [usuario, setUsuario] = useState(null);
  const [equipos, setEquipos] = useState([]);
  const [loadingGlobal, setLoadingGlobal] = useState(false);
  const [datosJugadores, setDatosJugadores] = useState([]);
  const [jugador, setJugador] = useState(null);
  const [estadisticasEquipo, setEstadisticasEquipo] = useState(null);
  const [equipoSeleccionado, setEquipoSeleccionado] = useState(null);
  const [clasificacionEquipo, setClasificacionEquipo] = useState(null);
  const [tipo, setTipo] = useState(null);
  const [posicion, setPosicion] = useState(null);
  const [tipos, setTipos] = useState([]);
  const [posiciones, setPosiciones] = useState([]);

  useEffect(() => {
    window.localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(filters));
  }, [filters]);

  // Reset de toda la sección "clasificaciones"
  const resetClasificaciones = () => {
    setClasificaciones((prev) => ({
      ...prev,
      clasificaciones: { temporada: "", tabla: [] },
    }));
  };

  const resetPartidos = () => {
    setJornadas([]);
  };

  return (
    <AppContext.Provider
      value={{
        jornadas,
        setJornadas,
        filters,
        setFilters,
        usuario,
        setUsuario,
        equipos,
        setEquipos,
        loadingGlobal,
        setLoadingGlobal,
        clasificaciones,
        setClasificaciones,
        resetClasificaciones,
        resetPartidos,
        datosJugadores,
        setDatosJugadores,
        jugador,
        setJugador,
        estadisticasEquipo,
        setEstadisticasEquipo,
        equipoSeleccionado,
        setEquipoSeleccionado,
        clasificacionEquipo,
        setClasificacionEquipo,
        tipo,
        setTipo,
        posicion,
        setPosicion,
        tipos,
        setTipos,
        posiciones,
        setPosiciones,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
